// The coupon form's "percent off per package" table (admin/coupons/_form) is
// refetched whenever the pricelist select changes. That select is a React
// island (admin/Forms/PackageSelect) writing its ids into a hidden input, and
// it is mounted AFTER the modal's inline script has run: coupons.js injects
// the form with .html() -- which evaluates the script -- and only then calls
// ReactRailsUJS.mountComponents(). So the input cannot be looked up once at
// script time; it has to be found afresh on every tick, and nothing happens
// until it exists. (The first cut did the one-time lookup and the table never
// filled: "There are none listed here for me to choose from", 2026-10-26.)
//
// Exposed on window by packs/application.js for the inline script, as the
// other form helpers are.

// One canonical spelling of an id set -- "12,7", ["7", 12] and "7, 12,,0" are
// the same set -- so a reordering is not mistaken for a change.
export function idKey(value) {
  const raw = Array.isArray(value) ? value : String(value == null ? '' : value).split(',');
  const ids = raw.map((v) => parseInt(v, 10)).filter((n) => Number.isInteger(n) && n > 0);
  return Array.from(new Set(ids)).sort((a, b) => a - b).join(',');
}

// Returns a tick() for the caller's timer. `findInput` is asked every tick
// and may return null until the island mounts; `baseline` is the id set the
// table was server-rendered for, so a change made before the first tick is
// still caught; `onChange` gets the new sorted-id string.
export function pricelistWatcher({ findInput, baseline, onChange }) {
  let last = idKey(baseline);
  return function tick() {
    const input = findInput();
    if (!input) return;
    const current = idKey(input.value);
    if (current === last) return;
    last = current;
    onChange(current);
  };
}
